import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigModule, I18nModule } from '@spartacus/core';
import {
  ActiveFacetsModule,
  AtMessageModule,
  FacetListModule,
  FacetModule,
  IconModule, KeyboardFocusModule,
  TabModule
} from '@spartacus/storefront';
import { EfaActiveFacetsComponent } from './components/efa-active-facets/efa-active-facets.component';
import { EfaFacetListComponent } from './components/efa-facet-list/efa-facet-list.component';
import { EfaFacetComponent } from './components/efa-facet/efa-facet.component';
import { EfaProductFacetNavigationComponent } from './components/efa-product-facet-navigation/efa-product-facet-navigation.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FacetListModule,
        FacetModule,
        ActiveFacetsModule,
        IconModule,
        I18nModule,
        TabModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ProductRefinementComponent: {
                    component: EfaProductFacetNavigationComponent,
                },
            },
        }),
        AtMessageModule,
        KeyboardFocusModule,
        EfaProductFacetNavigationComponent,
        EfaFacetListComponent,
        EfaFacetComponent,
        EfaActiveFacetsComponent
    ],
    exports: [EfaProductFacetNavigationComponent]
})
export class ProductFacetNavigationModule { }
